import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveProvince } from '../../shared/components/SaveProvince';

export type CreateProvincePageProps = {};

const CreateProvincePage: React.FC<CreateProvincePageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_provincia);

  return <SaveProvince titlePage="Crear Provincia" />;
};

export default CreateProvincePage;
